
import colors from "assets/theme/base/colors";

const { black } = colors;

const list = {
  styleOverrides: {
    padding: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    root: {
      color: black.main, 
    }

  },
};

export default list;
